'use client';

import { createContext } from 'react';

import type { IconButtonRootContextInterface } from '../types/icon-button-root.types';

export const IconButtonRootContext = createContext<IconButtonRootContextInterface>({});

IconButtonRootContext.displayName = 'IconButton.Root.Context';
